module.exports = __webpack_public_path__ + "static/img/15075B_R_2_3_4_20180406_LC.3bcb581.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/15075B_R_2_3_4_20180406_LC.png
// module id = IL9w
// module chunks = 0